// A name is never blank (firestore.rules refuse one), and an unchanged name is not rewritten: both return null.
export const getNameToSave = (input: string, stored: string): string | null => {
  const name = input.trim();
  return name && name !== stored ? name : null;
};
